import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Footer } from '@codex-applications/header';

import LayoutWrapper from '../PageLayoutComponents/LayoutWrapper';

const FooterWrapper = styled.div`
  margin-top: 20px;
`;

const FooterContainer = ({ initialNavigation, initialCopyright }) => (
  <LayoutWrapper wrapperName={'footer'}>
    <FooterWrapper>
      <Footer
        initialNavigation={initialNavigation}
        initialCopyright={initialCopyright}
        useOnlyInitialData
      />
    </FooterWrapper>
  </LayoutWrapper>
);

FooterContainer.propTypes = {
  initialNavigation: PropTypes.shape({}).isRequired,
  initialCopyright: PropTypes.shape({}).isRequired
};

const mapStateToProps = ({ configuration }) => {
  const { navigationData } = configuration;
  return {
    initialNavigation: navigationData?.footer.nav[0],
    initialCopyright: navigationData?.footer.nav[1]
  };
};

export default connect(mapStateToProps)(FooterContainer);
